// TODO: The current implementation of fading with contentScrollHandler is not behaving well
// with objects of variable length should switch to absolute scale rather than relative.
// Also have so far been unable to get the fading effect on modal load for the contact info panel.
/*
export const contentScrollHandler = (e, cutOff = 0.01, length = 5) => {
  const { target } = e;
  const { scrollTop, clientHeight, scrollHeight } = target;

  const topPercentage = scrollTop / scrollHeight;
  const bottomPercentage = (scrollTop + clientHeight) / scrollHeight;

  const gradient = 1 / cutOff;

  const topOpacity = topPercentage < cutOff ? 1 - gradient * topPercentage : 0;
  const bottomOpacity =
    bottomPercentage > 1 - cutOff ? 1 - gradient * (1 - bottomPercentage) : 0;

  return `mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, ${topOpacity}) ${topPercentage * 100}%,
    black ${topPercentage * 100 + length}%,
    black ${bottomPercentage * 100 - length}%,
    rgba(0, 0, 0, ${bottomOpacity}) ${bottomPercentage * 100}%
  )`;
};
*/

export const toProps = (cls, base) => ({
  backgroundColor: `activity${base}_5`,
  color: `activity${base}_50`,
  class: cls,
});
